import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { SettingsProvider } from './lib/settings'
import { AuthProvider, useAuth } from './lib/auth'
import Sidebar from './components/layout/Sidebar'
import HomesPage from './pages/HomesPage'
import HomeDetailPage from './pages/HomeDetailPage'
import RoomDetailPage from './pages/RoomDetailPage'
import StatusBoardPage from './pages/StatusBoardPage'
import SettingsPage from './pages/SettingsPage'
import LoginPage from './pages/LoginPage'
import './index.css'

function AppShell() {
  const { session, loading } = useAuth()

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--offwhite)' }}>
        <div className="loading">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 12a9 9 0 11-6.219-8.56">
              <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur=".8s" repeatCount="indefinite"/>
            </path>
          </svg>
        </div>
      </div>
    )
  }

  if (!session) return <LoginPage />

  return (
    <SettingsProvider>
      <div className="app-shell">
        <Sidebar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomesPage />} />
            <Route path="/homes/:homeId" element={<HomeDetailPage />} />
            <Route path="/homes/:homeId/rooms/:roomId" element={<RoomDetailPage />} />
            <Route path="/status" element={<StatusBoardPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </main>
      </div>
    </SettingsProvider>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  )
}
